// Google Analytics 4 (gtag.js) integration.
// Loaded only in production builds to keep local/dev traffic out of GA4.
export const GA_MEASUREMENT_ID = "G-F9ZG75HTL6";

const isProd = process.env.NODE_ENV === "production";

let initialized = false;

export function initGA() {
  if (!isProd || initialized || typeof window === "undefined") return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // This GA4 stream's Enhanced Measurement already tracks SPA route changes
  // via the browser history API (pushState/popState) automatically — verified
  // by observing a page_view fire on client-side navigation in this app.
  // Sending page_view manually here as well would double-count every route
  // change, so we rely entirely on GA4's built-in history-based tracking.
  gtag("config", GA_MEASUREMENT_ID);
}

export function trackEvent(name, params = {}) {
  if (!isProd || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
